<ng-container *ngIf="touched">
    <mat-error #errorMessage class="error-message" *ngFor=" let errorMessage of errorMessages$ | async" >
        {{ errorMessage }}
    </mat-error>
</ng-container>
